import axios from "axios";

export async function createVotePurchaseCheckout(
  { competitionId, packVotes, returnOrigin, returnDeepLink },
  token
) {
  const body = {
    competitionId,
    packVotes,
  };

  if (returnDeepLink) {
    body.returnDeepLink = returnDeepLink;
  } else {
    body.returnOrigin =
      returnOrigin ||
      (typeof window !== "undefined" ? window.location.origin : undefined);
  }

  const response = await axios.post(
    `${process.env.REACT_APP_API_URL_USER}/createVotePurchaseCheckout`,
    body,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}

export async function confirmVotePurchaseSession(sessionId, token) {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL_USER}/confirmVotePurchaseSession`,
    { sessionId },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}
